import React from 'react';

const BarberSelectionMessage = () => (
  <p className="u-text-justify u-type--semibold epsilon u-co-black-2">
    By selecting your Professional, you are letting the ownership know that you would like for the purchase
    price of the Gift Card to be allocated to this particular Professional.
    By selecting “Any Professional” you are purchasing a general Gift Card
    that you will be able to use with any Professional at the shop.
  </p>
);

export default BarberSelectionMessage;



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/GiftCard/BarberSelectionMessage.jsx